import { render, staticRenderFns } from "./PostChatForm.vue?vue&type=template&id=06b44824&scoped=true&"
import script from "./PostChatForm.vue?vue&type=script&lang=js&"
export * from "./PostChatForm.vue?vue&type=script&lang=js&"
import style0 from "./PostChatForm.vue?vue&type=style&index=0&id=06b44824&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06b44824",
  null
  
)

export default component.exports